import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Trash2, Check } from "lucide-react";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/inquiries");
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/admin/inquiries/${id}/read`);
    setItems((arr) => arr.map((i) => (i.id === id ? { ...i, read: true } : i)));
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this inquiry?")) return;
    await api.delete(`/admin/inquiries/${id}`);
    setItems((arr) => arr.filter((i) => i.id !== id));
  };

  const unread = items.filter((i) => !i.read).length;

  return (
    <div data-testid="admin-inquiries-page">
      <p className="label-eyebrow mb-2">Studio · Messages</p>
      <h1 className="font-display text-4xl mb-2">Inquiries</h1>
      <p className="text-[var(--text-secondary)] text-sm mb-8">
        {items.length} total · {unread} unread
      </p>

      {loading ? (
        <p className="text-[var(--text-secondary)]">Loading...</p>
      ) : items.length === 0 ? (
        <div className="admin-card p-12 text-center">
          <p className="text-[var(--text-secondary)]">No inquiries yet.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((it) => (
            <div
              key={it.id}
              className={`admin-card p-6 ${it.read ? "" : "border-l-4 border-l-[var(--accent)]"}`}
              data-testid={`inquiry-${it.id}`}
            >
              <div className="flex items-start justify-between gap-4 mb-3">
                <div>
                  <p className="font-medium text-lg">{it.name}</p>
                  <p className="text-sm text-[var(--text-secondary)]">
                    {it.email}{it.phone ? ` · ${it.phone}` : ""}
                    {it.instrument_type ? ` · interested in: ${it.instrument_type}` : ""}
                  </p>
                  <p className="text-xs text-[var(--text-secondary)] mt-1">
                    {new Date(it.created_at).toLocaleString()}
                  </p>
                </div>
                <div className="flex gap-1">
                  <a href={`mailto:${it.email}`} className="p-2 hover:text-[var(--accent)]" title="Reply via email" data-testid={`reply-${it.id}`}>
                    <Mail size={16} />
                  </a>
                  {!it.read && (
                    <button onClick={() => markRead(it.id)} className="p-2 hover:text-[var(--secondary-accent)]" title="Mark read" data-testid={`read-${it.id}`}>
                      <Check size={16} />
                    </button>
                  )}
                  <button onClick={() => remove(it.id)} className="p-2 hover:text-red-700" title="Delete" data-testid={`del-${it.id}`}>
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
              <p className="text-[var(--text-primary)] whitespace-pre-wrap leading-relaxed border-t border-[var(--border)] pt-3 mt-3">
                {it.message}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
